import React from 'react'
import {Flex} from '/app/src/component'
import {connect} from 'react-redux'
import style from './style.css'
import DateTime from '/app/src/lib/DateTime'
import { withRouter } from 'react-router-dom'
import EmployeesSelector from '/app/src/model/Employee/selector';
import CustomerSelector from '/app/src/model/Customer/selector';
import SystemSelector from '/app/src/model/System/selector'

class Item extends React.Component {
    constructor(props){
        super(props)
        this._onMouseClick = this._onMouseClick.bind(this)
    }

    _onMouseClick(path){
        return () => {
            this.props.history.push(path)
        }
    }

    render() {
        const customerName = this.props.customerName;
        let ticket = this.props.ticket.toJS();
        let path='/history/preview/'+ticket.room

        let active = this.props.currentRoom === ticket.room
        return (
            <Flex
                onClick={this._onMouseClick(path)}
                basis='83px' width='100%'
                className={style.Item} vAlignContent='center'
                border={active?'3px solid #4ec1e0':'3px solid transparent'}
                borderRadius='60px'
                backgroundColor={active&&'#f4fdff'}
                backgroundHover = {active?'#f4fdff':'#f7f7f7'}
                >
                <Flex width='20%' hAlignContent='center' className={style.Number}>
                    # {ticket.company_ticket_id}
                </Flex>
                <Flex width='20%' hAlignContent='center' className={style.Number}>
                    {customerName}
                </Flex>
                <Flex width='20%' hAlignContent='center' className={style.Name}>
                    <div className={style.Ellipsis}>{this.props.employeeName}</div>
                </Flex>
                <Flex width='20%' hAlignContent='center' className={style.Date}>
                    {DateTime.getDetailedNiceDate(ticket.date_created)}
                </Flex>
                <Flex width='20%' hAlignContent='center' className={style.Date}>
                    {DateTime.getDetailedNiceDate(ticket.date_resolved)}
                </Flex>
            </Flex>
        )
    }
}

function mapStateToProps(state, props) {
    const employee = EmployeesSelector.getById(state, props.ticket.get('assigned_employee_id'))
    const name = EmployeesSelector.getEmployeeName(employee)
    const customer = CustomerSelector.byId(state, props.ticket.get('customer_id'));
    const customerName = CustomerSelector.getName(customer);

    //const currentRoom =  props.history.location.pathname.replace('/conversation/', '')
    let currentRoom = SystemSelector.getParams(state)[2]
    return {
        employeeName: name, currentRoom: currentRoom, customerName: customerName
    }
}


export default connect(mapStateToProps)(withRouter(Item));



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/History/Item.js